// extracted by mini-css-extract-plugin
export default {"container":"MediaVideo_container__sK5zK","videoContainer":"MediaVideo_videoContainer__JfgmL"};